var Translations;

(function (Translations) {
  Translations["BACK_TO_SIGN_IN"] = "Back to Sign In";
  Translations["CHANGE_PASSWORD_ACTION"] = "Change";
  Translations["CHANGE_PASSWORD"] = "Change Password";
  Translations["CODE_LABEL"] = "Verification code";
  Translations["CODE_PLACEHOLDER"] = "Enter code";
  Translations["CONFIRM_SIGN_UP_CODE_LABEL"] = "Confirmation Code";
  Translations["CONFIRM_SIGN_UP_CODE_PLACEHOLDER"] = "Enter your code";
  Translations["CONFIRM_SIGN_UP_HEADER_TEXT"] = "Confirm Sign up";
  Translations["CONFIRM_SIGN_UP_LOST_CODE"] = "Lost your code?";
  Translations["CONFIRM_SIGN_UP_RESEND_CODE"] = "Resend Code";
  Translations["CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT"] = "Confirm";
  Translations["CONFIRM_SMS_CODE"] = "Confirm SMS Code";
  Translations["CONFIRM_TOTP_CODE"] = "Confirm TOTP Code";
  Translations["CONFIRM"] = "Confirm";
  Translations["CREATE_ACCOUNT_TEXT"] = "Create account";
  Translations["EMAIL_LABEL"] = "Email Address *";
  Translations["EMAIL_PLACEHOLDER"] = "amplify@example.com";
  Translations["FORGOT_PASSWORD_TEXT"] = "Forgot your password?";
  Translations["LESS_THAN_TWO_MFA_VALUES_MESSAGE"] = "Less than two mfa types available";
  Translations["NEW_PASSWORD_LABEL"] = "New password";
  Translations["NEW_PASSWORD_PLACEHOLDER"] = "Enter your new password";
  Translations["NO_ACCOUNT_TEXT"] = "No account?";
  Translations["PASSWORD_LABEL"] = "Password *";
  Translations["PASSWORD_PLACEHOLDER"] = "Enter your password";
  Translations["PHONE_LABEL"] = "Phone Number *";
  Translations["PHONE_PLACEHOLDER"] = "(555) 555-1212";
  Translations["QR_CODE_ALT"] = "qrcode";
  Translations["RESET_PASSWORD_TEXT"] = "Reset password";
  Translations["RESET_YOUR_PASSWORD"] = "Reset your password";
  Translations["SELECT_MFA_TYPE_HEADER_TEXT"] = "Select MFA Type";
  Translations["SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT"] = "Verify";
  Translations["SEND_CODE"] = "Send Code";
  Translations["SETUP_TOTP_REQUIRED"] = "TOTP needs to be configured";
  Translations["SIGN_IN_ACTION"] = "Sign In";
  Translations["SIGN_IN_HEADER_TEXT"] = "Sign in to your account";
  Translations["SIGN_IN_TEXT"] = "Sign in";
  Translations["SIGN_IN_WITH_AMAZON"] = "Sign in with Amazon";
  Translations["SIGN_IN_WITH_AUTH0"] = "Sign in with Auth0";
  Translations["SIGN_IN_WITH_AWS"] = "Sign in with AWS";
  Translations["SIGN_IN_WITH_FACEBOOK"] = "Sign in with Facebook";
  Translations["SIGN_IN_WITH_GOOGLE"] = "Sign in with Google";
  Translations["SIGN_OUT"] = "Sign Out";
  Translations["SIGN_UP_EMAIL_PLACEHOLDER"] = "Email";
  Translations["SIGN_UP_HAVE_ACCOUNT_TEXT"] = "Have an account?";
  Translations["SIGN_UP_HEADER_TEXT"] = "Create a new account";
  Translations["SIGN_UP_PASSWORD_PLACEHOLDER"] = "Password";
  Translations["SIGN_UP_SUBMIT_BUTTON_TEXT"] = "Create Account";
  Translations["SIGN_UP_USERNAME_PLACEHOLDER"] = "Username";
  Translations["SUCCESS_MFA_TYPE"] = "Success! Your MFA Type is now:";
  Translations["TOTP_HEADER_TEXT"] = "Scan then enter verification code";
  Translations["TOTP_LABEL"] = "Enter Security Code:";
  Translations["TOTP_SETUP_FAILURE"] = "TOTP Setup has failed";
  Translations["TOTP_SUBMIT_BUTTON_TEXT"] = "Verify Security Token";
  Translations["TOTP_SUCCESS_MESSAGE"] = "Setup TOTP successfully!";
  Translations["UNABLE_TO_SETUP_MFA_AT_THIS_TIME"] = "Failed! Unable to configure MFA at this time";
  Translations["USERNAME_LABEL"] = "Username *";
  Translations["USERNAME_PLACEHOLDER"] = "Enter your username";
  Translations["VERIFY_CONTACT_EMAIL_LABEL"] = "Email";
  Translations["VERIFY_CONTACT_HEADER_TEXT"] = "Account recovery requires verified contact information";
  Translations["VERIFY_CONTACT_PHONE_LABEL"] = "Phone Number";
  Translations["VERIFY_CONTACT_SUBMIT_LABEL"] = "Submit";
  Translations["VERIFY_CONTACT_VERIFY_LABEL"] = "Verify";
})(Translations || (Translations = {}));

export { Translations as T };